import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class GuardsService {
	logoutGuardRedirectCommands: any[] = [''];
	navigateAfterLoginCommands: any[] = [''];
}
